import { X } from "lucide-react"

import { cn } from "@/lib/utils"

export const nowCallingSurfaceClass =
  "border-slate-300 bg-gradient-to-b from-slate-100 to-slate-200"

export const handleColumnClass =
  "box-border flex w-full min-w-0 flex-col self-stretch border-l border-slate-300/80 bg-gradient-to-b from-slate-100 via-slate-200 to-slate-300 shadow-[inset_0_1px_0_rgb(255_255_255/0.5)]"

export const handleColumnButtonClass =
  "flex w-full shrink-0 items-center justify-center border-b border-slate-300/80 py-2.5 text-slate-600 transition-colors hover:bg-slate-300/40"

export const handleColumnWidthClass = "w-[calc(1.5cm*0.67)]"

/** Keypad panel width when total popover was min(19.5rem, 92vw) minus handle column. */
export const keypadPanelWidthClass =
  "w-[min(calc(19.5rem-1.5cm*0.67),calc(92vw-1.5cm*0.67))]"

export const nowCallingPopoverContentClass =
  "z-[100] min-w-0 overflow-visible border-0 bg-transparent p-0 shadow-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=top]:slide-in-from-bottom-2"

export function NowCallingPopoverHandle({
  closeLabel,
  onClose,
  className,
}: {
  closeLabel: string
  onClose: () => void
  className?: string
}) {
  return (
    <div className={cn(handleColumnClass, handleColumnWidthClass, className)}>
      <button
        type="button"
        aria-label={closeLabel}
        className={handleColumnButtonClass}
        onClick={onClose}
      >
        <X className="size-4" strokeWidth={2.25} />
      </button>
      <div className="min-h-0 flex-1" aria-hidden />
    </div>
  )
}
